/**
 * Favoritos sin app ni cuenta: la lista de handles de producto vive en el
 * localStorage del navegador. No cruza dispositivos y desaparece si el
 * visitante borra los datos del sitio; a cambio no necesita consentimiento
 * (es un servicio que el propio visitante pide) ni ningún servidor.
 *
 * Piezas en el tema:
 *   - snippets/favourite-toggle.liquid  → botones [data-favourite-toggle]
 *   - sections/header.liquid            → .favourites-link con [data-favourites-count]
 *   - sections/main-favourites.liquid   → página [data-favourites-page]
 *   - sections/favourites-card.liquid   → tarjeta que la página pide por la
 *                                         Section Rendering API, producto a producto
 *
 * Los textos llegan por data-* del <script> (layout/theme.liquid) con el
 * marcador [PRODUCT], para no hardcodear nada en JS.
 *
 * El tema reescribe trozos del DOM sin recargar (merge de la cabecera al
 * añadir al carrito, cambio de variante, quick buy, paginación AJAX). Un
 * MutationObserver vuelve a sincronizar los botones y el contador cada vez
 * que aparece markup nuevo con ellos, así ningún botón se queda desfasado.
 */
(function () {
  'use strict';

  var KEY = 'lgc_favourites';
  var MAX = 60;
  var script = document.currentScript;
  var msgs = (script && script.dataset) || {};

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY));
      if (!Array.isArray(list)) return [];
      return list.filter(function (h) { return typeof h === 'string' && h; });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      // Modo privado o almacenamiento bloqueado: la lista dura lo que la página.
      memory = list.slice(0, MAX);
    }
  }

  // Respaldo cuando localStorage no está disponible.
  var memory = null;
  function current() {
    return memory !== null ? memory.slice() : read();
  }

  function fill(template, title) {
    return (template || '').replace('[PRODUCT]', title || '');
  }

  function has(handle) {
    return current().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = current();
    var index = list.indexOf(handle);
    var saved = index === -1;
    if (saved) {
      list.unshift(handle);
    } else {
      list.splice(index, 1);
    }
    write(list);
    sync();
    document.dispatchEvent(new CustomEvent('on:favourites:change', {
      bubbles: true,
      detail: { handle: handle, saved: saved, list: current() }
    }));
    return saved;
  }

  function syncToggle(btn, list) {
    var handle = btn.getAttribute('data-favourite-toggle');
    var saved = list.indexOf(handle) !== -1;
    var title = btn.getAttribute('data-product-title') || '';
    btn.classList.toggle('is-saved', saved);

    var text = btn.querySelector('[data-favourite-text]');
    if (text) {
      // Ficha de producto: el texto visible es el nombre accesible.
      var label = saved ? btn.dataset.textRemove : btn.dataset.textAdd;
      if (label) text.textContent = label;
    } else {
      var name = fill(saved ? msgs.labelRemove : msgs.labelAdd, title);
      if (name) btn.setAttribute('aria-label', name);
    }
  }

  function sync() {
    var list = current();
    document.querySelectorAll('[data-favourite-toggle]').forEach(function (btn) {
      syncToggle(btn, list);
    });
    document.querySelectorAll('[data-favourites-count]').forEach(function (el) {
      el.textContent = list.length ? String(list.length) : '';
    });
  }

  // Misma técnica que theme.announceCartChange: vaciar y escribir un frame
  // después, para que el lector anuncie aunque el texto se repita.
  function announce(message) {
    var region = document.getElementById('cart-add-live-region');
    if (!region || !message) return;
    region.textContent = '';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        region.textContent = message;
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-favourite-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-favourite-toggle');
    if (!handle) return;
    var saved = toggle(handle);
    announce(fill(saved ? msgs.announceAdd : msgs.announceRemove, btn.getAttribute('data-product-title')));
  });

  // Otra pestaña ha cambiado la lista.
  window.addEventListener('storage', function (e) {
    if (e.key === null || e.key === KEY) sync();
  });

  var syncScheduled = false;
  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    requestAnimationFrame(function () {
      syncScheduled = false;
      sync();
    });
  }

  function hasFavouriteMarkup(node) {
    if (node.nodeType !== 1) return false;
    if (node.matches('[data-favourite-toggle], [data-favourites-count]')) return true;
    return !!node.querySelector('[data-favourite-toggle], [data-favourites-count]');
  }

  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i += 1) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j += 1) {
        if (hasFavouriteMarkup(added[j])) {
          scheduleSync();
          return;
        }
      }
    }
  });

  window.theme = window.theme || {};
  window.theme.favourites = { list: current, has: has, toggle: toggle, sync: sync };

  /* ---------------------------------------------------------------
   * Página de favoritos
   *   Pide cada producto guardado a su propia URL con
   *   ?section_id=favourites-card, que devuelve la misma tarjeta que
   *   usan las colecciones (precio del mercado, idioma, etiquetas, "+"
   *   de compra rápida con tira de tallas). Un 404 significa que el
   *   producto ya no existe o no está publicado: se quita de la lista.
   * --------------------------------------------------------------- */
  function initPage(root) {
    var grid = root.querySelector('[data-favourites-grid]');
    var empty = root.querySelector('[data-favourites-empty]');
    var status = root.querySelector('[data-favourites-status]');
    var countEl = root.querySelector('[data-favourites-page-count]');
    var sectionId = root.getAttribute('data-section-id') || 'favourites-card';
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var texts = root.dataset;

    function setStatus(message) {
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
    }

    function plural(one, other, count) {
      return (count === 1 ? one : other || one || '').replace('[COUNT]', String(count));
    }

    function cardsInGrid() {
      return grid ? grid.querySelectorAll('product-block').length : 0;
    }

    function updateCount() {
      var n = cardsInGrid();
      if (countEl) countEl.textContent = n ? plural(texts.countOne, texts.countOther, n) : '';
      if (n === 0) {
        if (grid) grid.hidden = true;
        if (empty) empty.hidden = false;
      }
    }

    function fetchCard(handle) {
      var url = base + 'products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sectionId);
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (response) {
          if (response.status === 404) return { gone: true };
          if (!response.ok) return { error: true };
          return response.text().then(function (html) {
            var tpl = document.createElement('template');
            tpl.innerHTML = html;
            var card = tpl.content.querySelector('product-block');
            return card ? { card: card } : { gone: true };
          });
        })
        .catch(function () { return { error: true }; });
    }

    var list = current();
    if (!list.length) {
      setStatus('');
      updateCount();
      return;
    }

    root.setAttribute('aria-busy', 'true');
    Promise.all(list.map(fetchCard)).then(function (results) {
      var gone = [];
      var errors = 0;
      results.forEach(function (result, i) {
        if (result.card && grid) {
          grid.appendChild(result.card);
        } else if (result.gone) {
          gone.push(list[i]);
        } else {
          errors += 1;
        }
      });

      if (gone.length) {
        write(current().filter(function (h) { return gone.indexOf(h) === -1; }));
      }

      root.removeAttribute('aria-busy');
      if (grid && cardsInGrid()) grid.hidden = false;
      sync();
      updateCount();

      var notes = [];
      if (gone.length) notes.push(plural(texts.unavailableOne, texts.unavailableOther, gone.length));
      if (errors) notes.push(texts.loadError || '');
      setStatus(notes.join(' '));
    });

    // Quitar desde la propia página: fuera la tarjeta, y el foco al
    // siguiente marcador (o al título si era la última).
    document.addEventListener('on:favourites:change', function (e) {
      if (!grid || e.detail.saved) return;
      var btn = grid.querySelector('[data-favourite-toggle="' + CSS.escape(e.detail.handle) + '"]');
      var card = btn && btn.closest('product-block');
      if (!card) return;
      var next = card.nextElementSibling || card.previousElementSibling;
      card.remove();
      updateCount();
      var target = next ? next.querySelector('[data-favourite-toggle]') : document.querySelector('[data-favourites-heading]');
      if (target) {
        if (!target.hasAttribute('tabindex') && target.tagName !== 'BUTTON' && target.tagName !== 'A') target.setAttribute('tabindex', '-1');
        target.focus();
      }
    });
  }

  function start() {
    sync();
    observer.observe(document.body, { childList: true, subtree: true });
    var page = document.querySelector('[data-favourites-page]');
    if (page) initPage(page);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
